import React from 'react'
import {
  DepositLimitInfoIcon,
  PaymentLimitHelpText,
} from '@mobi/account/Areas/DepositLimit/Utils/PaymentLimitHelpText'

type Props = {
  depositLimits: { minimum: number; maximum: number }
  remainingDepositAmount: number
  remainingDepositTransactions: number
  showDepositLimitLink: boolean
  /** Shown instead of DepositLimitHelpText when the DEPOSIT_VALUE_VOLUME_LIMITS feature flag is off */
  fallback?: React.ReactNode
}

export const DepositLimitRow = ({
  depositLimits,
  remainingDepositAmount,
  remainingDepositTransactions,
  showDepositLimitLink,
  fallback,
}: Props) => (
  <>
    <dt>
      Daily Limit
      {!fallback && <DepositLimitInfoIcon showDepositLimitLink={showDepositLimitLink} />}
    </dt>
    <dd style={{ fontVariant: 'tabular-nums' }}>
      {fallback ?? (
        <PaymentLimitHelpText
          paymentType='deposit'
          paymentLimits={depositLimits}
          remainingPaymentAmount={remainingDepositAmount}
          remainingPaymentTransactions={remainingDepositTransactions}
          showDepositLimitLink={showDepositLimitLink}
          isInfoIconShown={false}
        />
      )}
    </dd>
  </>
)
